import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "../../i18n/TranslationProvider";

const TakeTourModal = ({
    show,
    onHide,
    videoId = "wqtlfTibazA",
}) => {
    const { t } = useTranslation();
    const cleanVideoId = videoId.split("?")[0]; // strip any accidental ?si=... tracking param

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            aria-labelledby="take-tour-modal"
        >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                {show && (
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe
                            key={cleanVideoId}
                            className="embed-responsive-item"
                            src={`https://www.youtube-nocookie.com/embed/${cleanVideoId}?autoplay=1&rel=0&modestbranding=1`}
                            title={t("taketourmodal.title")}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            referrerPolicy="strict-origin-when-cross-origin"
                            style={{ border: 0 }}
                        ></iframe>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default TakeTourModal;